import { TemplatePage } from './types';

const live_streaming_neon_smoke_theme: TemplatePage = {
  header: {
    color: '#9bb7ff',
    icon: 'images/video-templates/neon-smoke.jpg',
    title: 'Live Stream Templates — Neon Smoke',
    title_meta: '10+ Free Live Stream Overlay Templates — Neon Smoke Theme',
    description_meta:
      'Level up your live streams with Wave.video’s easily editable neon-smoke-themed overlay and transition ' +
      'screen templates.',
    description:
      'Level up your live streams with our easily editable neon-smoke-themed templates. Make high-quality branded ' +
      'overlays, transition screens, and frames that perfectly fit multistreaming services like' +
      ` <a href=https://wave.video/live-streaming/streaming-software class="blackLink">Wave.video Live Streaming Studio</a>.`
  },
  footer: {
    category: 'Live Stream Neon Smoke Theme',
    description:
      'Thanks to Wave.video’s themed collections of editable live stream templates, you can easily make your show ' +
      'look unique and highly professional. Impress your audience with beautiful intros, countdowns, thumbnails, ' +
      'lower thirds, and technical issue screens without spending a fortune on design. Becoming a professional live ' +
      'streamer has never been easier!'
  },
  content: [
    {
      type: 'templates',
      title: 'Neon Smoke Theme templates',
      search: { name: 'NeonSmoke', tags: 'NeonSmoke' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_neon_smoke_theme;
